import React from "react";
import { Paragraph } from "../styles/components/section";

const Component = props => {
  const content = props;

  const componentContent = content?.__typename
    ? {
        key: content.id,
        type: content.__typename,
        content: content.text,
      }
    : null;

  return (
    <>
      {componentContent &&
        (() => {
          switch (componentContent.type) {
            case "DatoCmsParagraph":
              return (
                <Paragraph key={componentContent.key}>
                  {componentContent.content}
                </Paragraph>
              );
            default:
              return null;
          }
        })()}
    </>
  );
};

export default Component;
